/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Home,
} from '../models/index';
import {
    HomeFromJSON,
} from '../models/index';

/**
 *
 */
export class HomeApi extends runtime.BaseAPI {

    /**
     * Get Home Page
     */
    async getHomePageApiHomeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Home>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/home`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeFromJSON(jsonValue));
    }

    /**
     * Get Home Page
     */
    async getHomePageApiHomeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Home> {
        const response = await this.getHomePageApiHomeGetRaw(initOverrides);
        return await response.value();
    }

}
